export default __webpack_public_path__ + "static/media/Mother.aaaa4e62.svg";